<template>
  <div class="web-container">
    <!--页面顶部-->
    <a href="#" name="index"></a>
    <div class="content-container page-header">
      <div class="flex flex-dr flex-center">
        <div class="web-title flex flex-dr flex-center">
<!--          <img :src="webConfig.logoUrl" alt="" class="logo">-->
          <span class="title" style="margin-top: 30px">{{ webConfigNew.base.organ }}</span>
          <span class="title">{{ webConfigNew.base.title }}</span>
        </div>
      </div>
    </div>
    <!--顶部导航-->
    <nut-tabbar
        @tab-switch="tabSwitch3"
        :tabbar-list="navList"
        :bottom="true"
    >
    </nut-tabbar>
    <!--轮播图-->
    <div class="focus-container ">
      <nut-swiper class="swiper"
                  direction="horizontal"
                  :loop="true"
                  :autoPlay="2000"
                  :canDragging="false"
                  :paginationVisible="true"
                  :key="swiperKey"
                  ref="demo2"
      >
        <div v-for="(item,index) in focusList" :key="index" class="nut-swiper-slide" v-if="item.show">
          <img :src="item.image" class="nut-img" alt=""/>
        </div>

      </nut-swiper>
    </div>
    <!--中心介绍-->
    <a href="#" name="center"></a>
    <div class="li-container content-container">
      <el-divider content-position="center" class="content-title">中心介绍</el-divider>
      <div class="content-html html-view">
        <p v-for="item in webConfigNew.center.content.split('\n')">{{ item }}</p>
      </div>
    </div>
    <!--项目介绍-->
    <a href="#" name="experiment"></a>
    <div class="content-container experiment-container">
      <el-divider content-position="center" class="content-title">项目介绍</el-divider>
      <!--实验介绍-->
      <div class="experiment-container flex flex-dr flex-center">
        <div class="list flex flex-dr flex-center">
          <div class="li" v-for="(experiment,experimentIndex) in experiments.list">
            <img :src="experiment.product_iconLeft" alt="" class="left-icon" v-if="experiment.product_iconLeft"
                 style="z-index: 1">
            <div class="bg">
              <img :src="experiment.product_bg" alt="">
            </div>
            <div class="info">
              <img class="avatar" :src="experiment.product_icon" alt="">
              <div class="title">{{ experiment.name }}</div>
              <div class="des-main word-hr ellipsis">{{ experiment.subName }}</div>
              <!--最多3行 每行18字 第三行超出省略号显示-->
              <div class="des word-hr ellipsis" v-html="experiment.description"></div>
              <div class="buttons">
                <a class="button" @click="ExperimentMethods().clickViewExperiment(experiment)">查看详情</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--产品介绍弹窗-->
    <nut-popup position="bottom" get-container="body" v-model="experimentInfo.dialog" :destroy-on-close="true" closeable
               close-icon="cross" close-icon-position="top-right"
               :style="{ height: '80%' }">
      <div class="experiment-dialog">
        <div class="header flex flex-dr flex-center"
             :style='"background-image: url("+experimentInfo.experiment.product_info_bg+")"'>
          <img :src="experimentInfo.experiment.product_icon" alt="" class="avatar">
          <div class="title">{{ experimentInfo.experiment.name }}</div>
          <div class="series-name">{{ experimentInfo.experiment.seriesName }}</div>
        </div>
        <div class="info-box">
          <div class="des">
            <div>实验简介：</div>
            <div class="view">
              <p v-for="p in experimentInfo.experiment.experimentDescription.split('\n')">{{ p }}</p>
            </div>
          </div>
          <div class="view-box">
            <!--todo 封面问题安卓和ios解决-->
            <div class="video-box" v-if="experimentInfo.experiment.product_video">
              <video id="v1" loop="" preload="auto" muted="" x-webkit-airplay="true" airplay="allow"
                     :poster="experimentInfo.experiment.name==='飞夺泸定桥'?'http://resouce.cdzyhd.com/6adb4edc-9226-4119-8419-366daff7e26a.png':''"
                     webkit-playsinline="true" playsinline="true" :src="experimentInfo.experiment.product_video"
                     class="video1 video"
                     draggable="true"></video>
              <img src="@/assets/icon/play.png" alt="" class="play-btn"
                   @click="e=>ExperimentMethods().playVideo(e)">
              <!--todo 加入全屏按钮-->
            </div>
            <el-image v-if="!experimentInfo.experiment.product_video&&experimentInfo.experiment.sample!==true"
                      class="video-box-no" fit="cover"
                      :src="experimentInfo.experiment.product_info_img"
                      @click="window.open(experimentInfo.experiment.product_info_img)"></el-image>
            <div class="img-box flex flex-around flex-wrap" v-if="experimentInfo.experiment.sample!==true">
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_1)"
                  class="img"
                  fit="cover"
                  :src="experimentInfo.experiment.product_info_img_1">
              </el-image>
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_2)"
                  class="img"
                  fit="cover"
                  :preview-src-list="experimentDialogPicList"
                  :src="experimentInfo.experiment.product_info_img_2">
              </el-image>
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_3)"
                  fit="cover"
                  class="img"
                  :preview-src-list="experimentDialogPicList"
                  :src="experimentInfo.experiment.product_info_img_3">
              </el-image>
              <el-image
                  @click="window.open(experimentInfo.experiment.product_info_img_4)"
                  fit="cover"
                  class="img"
                  :preview-src-list="experimentDialogPicList"
                  :src="experimentInfo.experiment.product_info_img_4">
              </el-image>
            </div>
          </div>
        </div>
      </div>
    </nut-popup>

    <!--友情链接-->
    <a href="#" name="link"></a>
    <div class="link-container content-container">
      <el-divider content-position="center" class="content-title">友情链接</el-divider>
      <div class="list flex flex-around flex-wrap">
        <div v-for="item in webConfigNew.friend.list" @click="clickLink(item)" v-if="item.show&&item.image">
          <el-image :src="item.image" alt="" class="li" fit="contain"></el-image>
          <div class="name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!--底部-->
    <div class="page-footer">
      <div class="info-container content-container">
        <div class="infos">
          <img :src="webConfig.logoUrl" alt="" class="logo">
          <p>{{ webConfigNew.base.organ }}{{ webConfigNew.base.title }}</p>
          <p>主办：{{ webConfigNew.base.organ }}</p>
          <p>技术支持</p>
          <p>成都智云鸿道信息技术有限公司 </p>

          <p style="cursor: pointer" @click="window.open('https://beian.miit.gov.cn/')">{{
              webConfig.beiAnText
            }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import elDragDialog from "@/directive/el-drag-dialog";
import {isMobile, shareStart} from "../../utils/common";
import {WEB_URL} from "../../model/ConfigModel";
import {OfficialWebExperimentModel} from "../../model/OfficialWebExperimentModel";
import {ErpConfigModel} from "../../model/ErpConfigModel";

export default {
  name: "web_cdkfdx",
  directives: {
    elDragDialog
  },
  components: {},
  data() {
    return {
      window: window,
      navIndex: "1",
      webConfig: {
        "logoUrl": "http://resouce.cdzyhd.com/2026-04-22/671d67fc-0519-4184-8921-dbcccbcac33b.png",
        beiAnText: "蜀ICP备19034784号-1",
        schoolId: "301339078173921280"
      },
      focusList: [],
      swiperKey: 0, // 添加swiperKey用于强制重新渲染
      webConfigNew: {
        focus: {
          list: []
        },
        base: {},
        center: {
          title:"",
          content:""
        },
        experiment: {
          showList: [],
          canList: [],
        },
        friend: {
          list: []
        }
      },
      experiments:{
        list:[]
      },
      experimentInfo: {
        dialog: false,
        experiment: {
          experimentDescription:""
        },
        list: []
      },
      experimentDialogPicList: [],
      navList: [
        {
          'tabTitle': '中心介绍',
          'curr': false,
          'icon': 'http://img13.360buyimg.com/uba/jfs/t1/10361/35/4713/4643/5c0f3d62E437a3c94/273fd0fb90798f03.jpg',
          'activeIcon': 'http://img14.360buyimg.com/uba/jfs/t1/26604/35/1073/7896/5c0f3d61Eb9f5f184/5f01c938abe4216d.jpg',
          'href': '#center'
        },
        {
          'tabTitle': '项目介绍',
          'curr': false,
          'icon': 'http://img12.360buyimg.com/uba/jfs/t1/25443/23/1062/4600/5c0f3d61E2e9f1360/c9b3421fe18614e2.jpg',
          'activeIcon': 'http://img20.360buyimg.com/uba/jfs/t1/19241/12/1048/8309/5c0f3d61E17ed5a56/c3af0964cade47f8.jpg',
          'href': '#experiment'
        },
        {
          'tabTitle': '教学系统',
          'curr': false,
          'icon': 'http://resouce.cdzyhd.com/4c482680-6607-4c92-8dc4-4d36a7d73787.png',
          'activeIcon': 'http://resouce.cdzyhd.com/5d968a97-eefe-4058-8c0e-b5192ea4d7b6.png',
          'href': 'http://exp.cdzyhd.com/login?schoolId=301339078173921280'
        },
        // {
        //   'tabTitle': '教学团队',
        //   'curr': false,
        //   'icon': 'http://img20.360buyimg.com/uba/jfs/t1/20004/20/1045/3620/5c0f3d61Eaaec1670/9e59db63983b7b9f.jpg',
        //   'activeIcon': 'http://img14.360buyimg.com/uba/jfs/t1/23967/14/1072/6714/5c0f3d61E0ad8991e/8f741953f6e38f15.jpg',
        //   'href': '#member'
        // },
        {
          'tabTitle': '友情链接',
          'curr': false,
          'icon': 'http://resouce.cdzyhd.com/28d7cdf5-9c34-47e9-84dc-527e93cc0244.png',
          'activeIcon': 'http://resouce.cdzyhd.com/1e72c019-f242-4404-9467-fd14d4f69b24.png',
          'href': '#link'
        },
      ]
    }
  },
  created() {
    // 判断是不是在移动端
    if (!isMobile()) {
      window.location.href = WEB_URL + this.$route.path
    }
  },
  async mounted() {
    // 获取官网配置
    this.webConfigNew = JSON.parse(await ErpConfigModel.getConfig("config_exp_officialWeb", this.webConfig.schoolId))
    this.$set(this,"focusList",this.webConfigNew.focus.h5)
    this.$forceUpdate()
    document.title = this.webConfigNew.base.organ+this.webConfigNew.base.title
    this.getExperimentConfig()
    // 配置微信分享参数
    setTimeout(() => {
      // 判断是否在微信内
      // 思政教育春风化雨，立德树人启智润心更多精彩思政资源
      if (navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
        shareStart(window.location.href, "成都开放大学", "习近平新时代中国特色社会主义思想、伟大建党精神、国家名片：数字丝路与时代担当、时代回响：直播主体的价值引领与时代担当……", "http://h5.exp.cdzyhd.com/images/logo/tjdzxxzyjsxy.png")
      }
    }, 500)

    // 修复swiper异步数据加载问题 - 通过改变key强制重新渲染
    this.$nextTick(() => {
      if (this.focusList && this.focusList.length > 0) {
        this.swiperKey++
      }
    })
  },
  methods: {
    // 获取产品配置
    async getExperimentConfig() {
      // 要获取的实验列表，和自定义属性
      let experimentList = []
      this.webConfigNew.experiment.showList.forEach(li => {
        experimentList.push({
          id: li
        })
      })
      let list = []
      for (let i = 0; i < experimentList.length; i++) {
        let id = experimentList[i]["id"]
        let experiment = await OfficialWebExperimentModel.getOneExperimentConfig(id)
        let experimentLast = Object.assign({}, experiment, experimentList[i])
        // 合并自定义项
        list.push(experimentLast)
        this.$set(this.experiments, "list", list)
      }
    },
    tabSwitch3: function (value, index) {
      console.log(index);
    },
    // 点击首页导航
    selectNav(v) {
      switch (v) {
        case "1":
          window.location.href = "#center"
          break;
        case "2":
          window.location.href = "#experiment"
          break;
        case "3":
          window.location.href = "#member"
          break;
        case "4":
          window.location.href = "#link"
          break;
        case "5":
          window.location.href = ""
          break;
      }
    },
    // 点击团队成员
    clickMember(item, index) {
      this.$set(this.member, "info", item)
      this.member.dialog = true
    },
    // 点击友情链接
    clickLink(item) {
      window.open(item.url)
    },
    // 实验项目方法集
    ExperimentMethods() {
      let $this = this;
      return {
        clickViewExperiment(experiment) {
          $this.experimentInfo.dialog = true
          $this.experimentDialogEnterBtn = false
          $this.$set($this.experimentInfo, "experiment", experiment);
          $this.experimentDialogPicList = [
            experiment.product_info_img_1,
            experiment.product_info_img_2,
            experiment.product_info_img_3,
            experiment.product_info_img_4,
          ]
          if (!experiment.product_video && experiment.product_info_img) {
            $this.experimentDialogPicList.push(experiment.product_info_img)
          }
          setTimeout(() => {
            $(".experiment-dialog .bg").css("background-image", `url(${experiment.product_info_bg})`)
          }, 100)
        },
        // 播放视频
        playVideo(e) {
          // this.videoPlay = true
          // document.querySelector("#v1").play()
          $this.experimentInfo.experimentVideoDialog = true
        }
      }
    }
  }
}
</script>
<style>
.nut-tab {
  padding: 0px !important;
  border: 0px !important;
  overflow-y: hidden;
}

.nut-tab-item {
  height: auto !important;
  padding: 0px !important;
}

.nut-tab-link {
  font-size: 27px !important;
}

.nut-tabbar .tabbar-nav:nth-child(3) .tabbar-nav-word {
  color: #de201a !important;
}
</style>
<style scoped lang="less">
@import '../../style/app.less';

.web-container {
  //background-color: #f2f2f2;
}

.content-title {
  margin-top: 40px;

  .el-divider__text {
    font-size: 40px;
    color: #777;
    font-weight: 450;
    text-align: center;
    margin-bottom: 20px;
  }

}

.page-header {
  width: 100%;
  background-color: #fff;
  z-index: 1999;

  .web-title {
    margin-top: 20px;

    .logo {
      width: 100%;
      //height: 120px;
      cursor: pointer;
      display: block;
      margin-bottom: 15px;
    }

    span.title {
      font-size: 40px;
      color: #666;
      font-weight: bold;
      margin-bottom: 10px;
    }
  }
}

.focus-container {
  margin-top: 30px;
  margin-bottom: 60px;

  .swiper {
    height: 550px;
  }

  .nut-img {
    object-fit: cover;
    height: 550px;
  }
}

.li-container {
  margin-bottom: 50px;

  .content-html {
    margin-top: 45px;
    padding: 0px 20px;
    text-indent: 2em;
    font-size: 28px;
    color: #666;
    line-height: 40px;
    letter-spacing: 3px;
  }
}

// 实验介绍
.experiment-container {
  margin-bottom: 100px;

  .main-title {
    margin-top: 83px;
    font-size: 36px;
    font-weight: bold;
    line-height: 46px;
    color: #333333;
  }

  .title-des {
    font-size: 28px;
    font-weight: 300;
    line-height: 37px;
    color: #333333;
    margin-top: 20px;
    margin-bottom: 60px;
  }

  .list {
    width: 670px;
    align-items: normal;

    .li {
      margin-bottom: 40px;
      position: relative;

      &:hover {
        .bg {
          img {
            transition: all 0.5s linear;
            transform: scale(1.1);
          }
        }

        .info {
          box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

          .avatar {
            margin-top: -40px;
            opacity: 0;
          }

          .des-main {
            opacity: 0;
          }

          .title {
            margin-top: -60px;
          }

          .des {
            display: -webkit-box;
          }

          .buttons {
            display: block;
          }
        }
      }

      img.left-icon {
        position: absolute;
        width: 120px;
        height: 120px;
        top: -10px;
        left: -10px;
        z-index: 10;
      }

      .bg {
        z-index: 1;
        width: 670px;
        height: 413px;
        overflow: hidden;

        img {
          width: 670px;
          height: 413px;
          display: block;
          transition: all 0.5s linear;
          transform: scale(1);
        }
      }

      .info {
        position: relative; // 解决margin-top负数 和同级div的z-index问题
        padding: 30px;
        height: 415px;
        width: 590px;
        margin: 0 auto;
        margin-top: -60px;
        text-align: center;
        background: #fff;
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        border-bottom: 3px solid transparent;
        transition: all 0.2s linear;

        .avatar {
          display: inline-block;
          width: 148px;
          height: 148px;
          position: relative;
          margin-top: 60px;
          transition: all 0.2s linear;
          box-shadow: 1px 3px 6px 2px #dedede;
        }

        .title {
          position: relative;
          font-size: 36px;
          font-weight: bold;
          margin-top: 30px;
          margin-bottom: 8px;
          transition: all 0.2s linear;
          line-height: 46px;
        }

        .des-main {
          font-size: 28px;
          line-height: 35px;
          transition: all 0.2s linear;
          color: #666;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          display: -webkit-box;
        }

        .des {
          font-weight: 300;
          font-size: 29px;
          display: none;
          color: #666;
          line-height: 35px;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }

        .buttons {
          display: none;
          text-align: center;
          margin-top: 15px;
        }

        .button {
          display: inline-block;
          width: 200px;
          line-height: 56px;
          border: 1px solid #d8d8d8;
          border-radius: 15px;
          text-align: center;
          font-size: 24px;
          color: #666666;
          position: relative;
          cursor: pointer;
          transition: all 0.2s linear;
          text-decoration: none;
          padding: 5px 20px;
          margin-top: 20px;

          &:hover {

          }
        }


      }
    }

    .li:last-child {
      margin-bottom: 0px;
    }
  }

  .more {
    text-align: center;
    cursor: pointer;
    transition: all 0.3s linear;
    width: 300px;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 30px;
    color: #707070;

    &:hover {
      transform: scale(1.1);
    }

    span {
      font-weight: 400;
      line-height: 21px;
      color: #999999;
      font-size: 32px;

    }

    i {
      margin-left: 10px;
    }
  }
}

.experiment-dialog {
  .header {
    width: 750px;
    height: 530px;
    background-size: cover;
    background-position: 50% 50%;
    -webkit-backface-visibility: hidden;

    .avatar {
      width: 178px;
      height: 178px;
    }

    .title {
      margin-top: 10px;
      font-size: 32px;
      font-weight: bold;
      line-height: 42px;
      color: #FFFFFF;
      text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
      opacity: 0.9;
    }

    .series-name {
      font-size: 28px;
      font-weight: 400;
      line-height: 37px;
      color: #FFFFFF;
      text-shadow: 0px 0px 4px rgba(0, 0, 0, 0.5);
      opacity: 0.9;
      margin-top: 10px;
    }

  }

  .info-box {
    padding: 20px 40px;
    font-size: 28px;
    font-weight: 400;
    line-height: 37px;
    color: #333333;

    .view {
      margin-top: 10px;
      font-size: 28px;
      font-weight: 400;
      line-height: 40px;
      color: #333333;
      text-indent: 2em;
    }

    .view-box {
      width: 100%;
      margin-top: 25px;
      margin-bottom: 65px;

      .video-box {
        width: 670px;
        height: 360px;
        position: relative;

        video {
          position: absolute;
          left: 0;
          top: 0;
          width: 670px;
          height: 360px;
          object-fit: fill;
          z-index: 1;
        }

        .play-btn {
          position: absolute;
          // 上下左右居中
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
          width: 108px;
          height: 108px;
          cursor: pointer;
          z-index: 2;
        }
      }

      .video-box-no {
        width: 670px;
        height: 360px;
        background-size: cover;
        background-position: 50% 50%;
        -webkit-backface-visibility: hidden;
      }

      .img-box {
        margin-top: 10px;

        .img {
          width: 330px;
          height: 105px;
          cursor: pointer;

          &:nth-child(1), &:nth-child(2) {
            margin-bottom: 11px;
          }
        }
      }
    }
  }
}

.member-list {
  margin: 0 auto;
  margin-top: 50px;
  margin-bottom: 55px;
  width: 100%;

  .title {
    margin-bottom: 20px;
    color: #555;
    font-size: 25px;
  }

  .avatar-list {
    padding-top: 20px;
    text-align: center;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 360px);

    .avatar-li {
      width: 360px;
      margin-bottom: 30px;

      .el-image {
        width: 360px;
        height: 360px;
        background-size: cover;
        background-position: 50% 50%;
        -webkit-backface-visibility: hidden;
        opacity: 1;
        transform: scale(1);
        cursor: pointer;
      }

      .name {
        width: 360px;
        text-align: center;
        margin-top: 15px;
        color: #888;
        font-size: 26px;
      }
    }
  }
}

.member-dialog {
  text-align: left;
  font-size: 28px;
  color: #888;
}

// 友情链接
.link-container {
  margin-bottom: 45px;
  padding: 0px 30px;

  .list {
    margin-top: 60px;
    text-align: center;
    display: grid;
    justify-content: space-between;
    grid-template-columns: repeat(auto-fill, 320px);
    grid-gap: 10px;

    .name {
      margin-top: 10px;
      color: #777;
      font-size: 26px;
    }
  }


  .li {
    width: 320px;
    height: 160px;
    margin-top: 10px;
    //margin-right: 10px;
    background-size: cover;
    background-position: 50% 50%;
    -webkit-backface-visibility: hidden;
    opacity: 1;
    transform: scale(1);
    border-radius: 4px;
    cursor: pointer;
    box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.1);

    &:hover {
      transition: all 0.3s linear;
      transform: scale(1.03);
    }
  }
}

.page-footer {
  background-color: #2d2d2d;
  padding: 20px 0px;
  padding-bottom: 35px;
  margin-bottom: 135px;

  .info-container {
    .logo {
      width: 70px;
      height: 70px;
      cursor: pointer;
      display: none;
    }

    .infos {
      text-align: center;
      color: @remark-color;
      font-size: 24px;

      span {
        margin-right: 10px;
      }
    }
  }
}
</style>
